export const seededRandom = (seed: string): number => {
  let value = stringToNumber(seed);
  let t = (value += 0x6d2b79f5);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

const stringToNumber = (string: string): number => {
  return parseInt(
    string
      .slice(string.length - 14)
      .split('')
      .map(a => a.charCodeAt(0) % 10)
      .join('')
  );
};
